// extracted by mini-css-extract-plugin
module.exports = {"explorationPage":"Explorations_explorationPage__25gQd","stacks":"Explorations_stacks__2r3Zb","desc":"Explorations_desc__2TbKc"};